module.exports = __webpack_public_path__ + "media/images/dot-grid-d07886e6b51afcaabb71dabf2d142ab3.png";